export const EVENTS = {
  MODAL: "@sam_events/modal",
};

export const MODAL_CONFIG = {
  rootId: "sam_controller",
  displayConfig: {
    number: 2,
    timePeriod: "week", // day || week || month
    restTime: 10000, // in milliseconds
  },
};

export const MODAL_TYPES = {
  MOTOR: "modal_motor",
};

export const TIME_PERIOD = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
};
